import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalUserProfile from '../../../../../stores/global-user-profile';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const finishLectureOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
) => {
  try {
    const res = await appApi.finishLecture(programId, courseId, lectureId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }
    await globalUserProfile.getUserProfile();
    toast.success('ההרצאה הסתיימה בהצלחה');
  } catch (error) {
    console.error('Failed to finish lecture:', error);
    toast.error('שגיאה בסיום ההרצאה. אנא נסה שוב.');
  }
};
